export default "__VITE_ASSET__BLaWxSr8__"